import * as React from "react"
import { Link } from "gatsby"
import { StoreContext } from "../context/store-context"
import { CartButton } from "./cart-button"
import SearchIcon from "../icons/search"
import {
  header,
  container,
  logo as logoCss,
  searchForm,
  searchIcon,
  searchInput
} from "./header.module.css"
import { StaticImage } from "gatsby-plugin-image"

export function Header() {
  const { lineItems } = React.useContext(StoreContext)

  const quantity = lineItems.length

  function SearchBar() {
    const [term, setTerm] = React.useState("")

    const searchSubmit = (e) => {
      // gatsby navigate not working, search component does not update with new query string.
      e.preventDefault()
      window.location.href = `/search?q=${term}`
    }

    return (
      <form onSubmit={searchSubmit} className={searchForm}>
        <input
          className={searchInput}
          type="text"
          value={term}
          onChange={(e) => {
            setTerm(e.target.value)
          }}
          placeholder="Search all products..."
        />
        <SearchIcon aria-hidden className={searchIcon} onClick={searchSubmit} />
      </form>
    )
  }

  return (
    <div className={container}>
      <header className={header}>
        <Link to="/" className={logoCss}>
          {/* <Logo /> */}
          <StaticImage src="../../static/logo-aqua.png" alt="Hoops & Crosses"></StaticImage>
        </Link>
        {/* <div>Free postage when you spend £45 or more on kits! */}
        {/* <div> */}
        <SearchBar />
        <CartButton quantity={quantity}/>
        {/* </div> */}
        {/* </div> */}
      </header>
    </div>
  )
}
